<template>
  <div class="modal_card">
    <div class="header">
      <h4 class="title">
        {{ translate('services.blocked_simcard.show_blocked_simcard') }}
      </h4>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-6">
          <label>
            {{ translate('services.blocked_simcard.status') }}
          </label>
          <tree-select
              :options="status_list"
              v-model="blocked_simcard.status"
              :placeholder="translate('services.blocked_simcard.status')"
              :clearable="false"
          />
        </div>
        <div class="col-md-6">
          <label>
            {{ translate('services.blocked_simcard.reason') }}
          </label>
          <tree-select
              :options="reason_list"
              v-model="blocked_simcard.reason"
              :placeholder="translate('services.blocked_simcard.reason')"
              :clearable="false"
              :max-height="200"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-1 icon">
          <span
              v-if="blocked_simcard.tariff_device.status"
              class="mdi mdi-currency-rub tariffication"
          />
        </div>
        <div class="col-md-1 icon">
          <span
              v-if="blocked_simcard.tariff_device.device_status"
              class="mdi mdi-access-point online" >
          </span>
          <span
              v-else
              class="mdi mdi-access-point-off offline" >
          </span>
        </div>

        <div class="col-md-5">
          <router-link :to="'/device/' + blocked_simcard.tariff_device.device_fid" class="link" @click.native="cancel">
            <fg-input
                v-model="device_name"
                type="text"
                :label="translate('services.blocked_simcard.device')"
                :placeholder="translate('services.blocked_simcard.device')"
                :disabled="true"
            />
          </router-link>
        </div>
        <div class="col-md-5">
          <fg-input
              v-model="blocked_simcard.tariff_device.tariff_name"
              type="text"
              :label="translate('services.blocked_simcard.tariff_name')"
              :placeholder="translate('services.blocked_simcard.tariff_name')"
              :disabled="true"
          />
        </div>

      </div>

      <div class="row">
        <div class="col-md-4">
          <label>
            {{ translate('services.blocked_simcard.simcard_profile_status') }}
          </label>
          <tree-select
              :options="simcard_profile_status_list"
              v-model="blocked_simcard.simcard_profile.status"
              :placeholder="translate('services.blocked_simcard.simcard_profile_status')"
              :disabled="true"
          />
        </div>
        <div class="col-md-4">
          <a :href="blocked_simcard.simcard_profile.mno_link" class="link">
            <fg-input
                v-model="blocked_simcard.simcard_profile.mno"
                type="text"
                :label="translate('services.blocked_simcard.mno')"
                :placeholder="translate('services.blocked_simcard.mno')"
                :disabled="true"
            />
          </a>
        </div>
        <div class="col-md-4">
          <fg-input
              v-model="blocked_simcard.simcard_profile.iccid"
              type="text"
              :label="translate('services.blocked_simcard.iccid')"
              :placeholder="translate('services.blocked_simcard.iccid')"
              :disabled="true"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <fg-input
              v-model="updated"
              type="text"
              :label="translate('services.blocked_simcard.ts_update')"
              :placeholder="translate('services.blocked_simcard.ts_update')"
              :disabled="true"
          />
        </div>
      </div>

      <div class="text-center buttons">
        <span
            v-if="has_changes"
            class="btn btn-success btn-fill btn-wd"
            @click.prevent="update_simcard()"
        >
          {{ translate("btn.edit") }}
        </span>
        <span
            class="btn btn-danger btn-fill btn-wd"
            @click.prevent="cancel()"
        >
          {{ translate("btn.close") }}
        </span>
      </div>
      <div class="clearfix"/>
    </div>
  </div>
</template>
<script>

const fields_to_check = ["status", "reason"];

export default {
  name: "ShowBlockedSimCard",
  data() {
    return {
      blocked_simcard: {}
    }
  },
  props: {
    blocked_simcard_info: {
      type: [Object, Array],
      default: {}
    }
  },

  created() {
    this.blocked_simcard = JSON.parse(JSON.stringify(this.blocked_simcard_info))
  },

  computed:{
    has_changes() {
      let main_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.blocked_simcard_info[key];
        return obj;
      }, {});

      let client_order_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.blocked_simcard[key];
        return obj;
      }, {});

      return JSON.stringify(main_info) !== JSON.stringify(client_order_info);
    },
    updated(){
      return this.get_date(this.blocked_simcard.ts_update)
    },
    device_name(){
      return this.blocked_simcard.tariff_device.device_fid + " / " + this.blocked_simcard.tariff_device.device_name
    },
    reason_list(){
      return this.$store.getters.getBlockedSimcardReason.map((reason) => {
        return {id: reason.id, label: reason.title}
      })
    },
    simcard_profile_status_list(){
      return [
        { id: -1, label: this.translate('status_info.undefined') },
        { id: 1, label: this.translate('status_info.active') },
        { id: 2, label: this.translate('status_info.blocked') },
        { id: 3, label: this.translate('status_info.prepare') },
        { id: 4, label: this.translate('status_info.stop') },
      ]
    },
    status_list(){
      return [
        { id: 1, label: this.translate('status_info.active') },
        { id: 0, label: this.translate('status_info.not_active') },
      ]
    }
  },

  methods: {
    update_simcard(){
      let simcard_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.blocked_simcard[key];
        return obj;
      }, {});

      this.$http.v1.updateBlockedSimcard(this.blocked_simcard.id, simcard_info, () => {
        this.global_notify("info", this.translate("services.blocked_simcard.simcard_deleted"));
        this.$emit('update')
      })
    },
    cancel() {
      this.$emit('close')
    },
  }
}
</script>
<style lang="scss" scoped>
.modal_card {
  width: 100%;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #252422;
  position: relative;
  border: 1px solid #ccc;
  min-height: 85px;
  background-color: #f8f8f8;
  padding: 10px;

  .header {
    .title {
      margin-top: 5px;
      text-align: center;
    }
  }

  .content {
    .row {
      margin-bottom: 10px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      .icon{
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        span.mdi{
          font-size: 20px;
          &.online{
            color: #15ab00;
          }
          &.tariffication{
            color: #3f93d3;
          }
        }
      }

      .mx-input {
        width: 100%;
      }

      .form-group {
        margin: 0;
      }
    }
  }
  .buttons{
    .btn {
      height: 40px;
      margin-right: 5px;
      &:last-child{
        margin-right: 0;
      }
    }
  }
}

</style>
